const storeSliceNames = {
    aiAssistant: 'aiAssistant',
    auth: 'auth',
    global: 'global',
    iotDevices: 'iotDevices',
    loyalty: 'loyalty',
    message: 'message',
    modal: 'modal',
    monitoring: 'monitoring',
    retail: 'retail',
    session: 'session',
    networks: 'networks',
    ble: 'ble',
    sidewalk: 'sidewalk',
};

export default storeSliceNames;
